import React, { useState, useEffect, Fragment } from "react";
import Button from "../../../../lib/ui/buttons/Button";
import InputField from '../../../../lib/ui/inputs/Input';
import Radio from '../../../../lib/ui/radio/Radio';
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import '../../../../lib/ui/imageicon/Styles.css';
import "../../../../layouts/Layouts.css";
import "../../../../ui-styles/list/inlineFiltersList.css";
import "../../../../ui-styles/picker/picker.css";
import '../../../../ui-styles/buttons/ButtonFilled.css';
import '../../../../ui-styles/animations/ripple.css';
import { dateFormat } from "../../../../lib/functions";
import Loader from "../../../../lib/ui/loader/Loader";
import DropDown from "../../../../lib/ui/dropdown/Dropdown";
import AddrDropDown from "../../../../lib/ui/dropdown/addressDropDown";
import { createUser, updateUser, getallClinics, getUserDetails, getAllAdmins } from "../../../../actions/users";
import { useHistory } from 'react-router-dom';
import { validateEmail, validateDob, validateLicense, validateLetters, validateSrvstrtDt, validateDcotorDob, valPnBoCc } from '../../../../lib/validation';
import statesList from "../../../../config/states.json";
import citiesList from "../../../../config/cities.json";
import countriesList from "../../../../config/countries.json";
import AddLicense from "./AddLicense";
import { toast } from 'react-toastify';
import DateFnsUtils from '@date-io/date-fns';
import VerifyPopup from "../../users/components/VerifyPopup";
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import LoaderSmall from "../../../smallLoader";
import { getDegree, getSpecialization, getDepartmentList } from "../../../../actions/configuration";
import CreatePopUp from "./createPopup";
import CreateDepartment from "../../../clinic/clinicConfiguration/departments/createDepartment";
import CreateSpecialization from "../../../clinic/clinicConfiguration/specialization/createSpecialization";
import CreateDegree from "../../../clinic/clinicConfiguration/degree/CreateDegree";
import AddCurrency from "./AddCurrency";
import currencies from '../../../../config/currency.json'
import {API} from 'aws-amplify';

const CreateDoctorForm = (props) => {
    const { dId, role, userId, l } = props;
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [addDefaultFee, setAddDefaultFee] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [error, setError] = useState({});
    const [firstName, setfirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const maxYear = new Date().getFullYear() - 21;
    const [dob, setDob] = useState(new Date().setFullYear(maxYear));
    const [srvstrtdt, setSrvstrtdt] = useState(new Date().valueOf());
    //    const [civilNumber, setCivilNumber] = useState('');
    const [email, setEmail] = useState('');
    const [gender, setGender] = useState('');
    const [payment, setPayment] = useState('free');
    const [title, setTitle] = useState('Dr.');
    const [phone, setPhone] = useState('');
    const [alternatePhone, setAlternatePhone] = useState('');
    const [currency, setCurrency] = useState('INR');
    const [smallLoading, setSmallLoading] = useState(false);
    const [licenses, setLicenses] = useState([{
        license: '',
        licenseNo: '',
        expirationDate: new Date().valueOf(),
        country: ''
    }]);
    const [qualification, setQualification] = useState({ id: '', value: '' });
    const [states, setStates] = useState([{
        value: "",
        label: l.select_state
    }]);
    const [cities, setCities] = useState([{
        value: "",
        label: l.select_city
    }]);
    const [address, setAddress] = useState('');
    const [country, setCountry] = useState('India');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [department, setDepartment] = useState({ value: '', id: '' });
    const [specialization, setSpecialization] = useState({ id: '', value: '' });
    const [specializations, setSpecializations] = useState([]);
    const [departments, setDepartments] = useState([{
        label: 'Select Departments',
        name: ''
    }]);
    const [degrees, setDegrees] = useState([]);
    const [pincode, setPincode] = useState('');
    const [clinics, setClinics] = useState([]);
    const [clinic, setClinic] = useState('');
    const [openPopup, setopenPopup] = useState(false);
    const [admins, setAdmins] = useState([]);
    const [adminId, setAdminId] = useState('');
    const [fee, setFee] = useState('');
    const [domainName, setDomainName] = useState(process.env.REACT_APP_defaultdomian);
    const [newpopup, setCreatePopup] = useState('');
    const [create, setCreate] = useState('');
    const [addChips, setAddChips] = useState([]);
    // const handleAddCurrency = () => {
    //     setAddCurrency(true)
    // }
    // const handleAddChips = () => {
    //     if (country && currencyType && currencyValue) {
    //         // Add new chip to the array
    //         setAddChips([...addChips, { country, currency: currencyType, value: currencyValue }]);
    //         // Clear input fields
    //         setCountry('');
    //         setCurrencyType('');
    //         setCurrencyValue('');
    //     }
    // };
    // const [deptValue, setDeptVal] = useState('');
    // const qualifications = [{ value: "", label: l.select_degree }, { value: "DO", label: "D.O." }, { value: "NP", label: "N.P." }, { value: "MBBS", label: "MBBS" }, { value: "BDS", label: "BDS" }, { value: "MD", label: "MD" }, { value: "MS", label: "MS" }, { value: "DNB", label: "DNB" }, { value: "MEM", label: "MEM" }, { value: "MCH", label: "MCH" }, { value: "DGO", label: "DGO" }, { value: "Diploma In Cardiology", label: "Diploma_IN_Cardiology" }]
    // const departments = [{ value: "", label: l.select_department, },{ value: "allopathy", label: "Allopathy" },{ value: "ayurvedic", label: "Ayurvedic" }, { value: "homeopathy", label: "Homeopathy" }, { value: "unani", label: "Unani" },]

    // const _domain = psl.parse(window.location.hostname);

    useEffect(() => {
        if (role === "SA") {
            getAllAdmins().then(res => {
                let _admins = [{
                    value: "",
                    label: l.select_admin
                }];
                res.data.forEach(ad => {
                    _admins.push({
                        label: ad.companyName,
                        value: ad.userId
                    });
                });
                setAdmins(_admins);
            }).catch(err => {
                console.log("err in all admin ==== ", err);
            });
        } else if (role === "CA") {
            setAdminId(userId);
        }
    }, [role, userId]);

    useEffect(() => {
        if (adminId !== '' && role === "CA") {
            let query = role === "C" ? `&clinicId=${userId}` : '';
            getallClinics(query).then(res => {
                if (res.status) {
                    let _clinics = [{
                        value: "",
                        label: l.select_clinic
                    }];
                    res.data.forEach(clinic => {
                        _clinics.push({
                            label: clinic.clinicName,
                            value: clinic.userId
                        });
                    });
                    setClinics(_clinics);
                }
            }).catch(err => {
                console.log("err ==== ", err);
            });
        } else {
            setClinics([{
                value: "",
                label: l.select_clinic
            }]);
        }
    }, [adminId, role]);

    useEffect(() => {
        if (dId) {
            setLoading(true);
            getUserDetails(dId).then(res => {
                setLoading(false);
                if (res.status) {
                    res?.data?.currency && setCurrency(res.data.currency);
                    setfirstName(res.data.firstName);
                    setLastName(res.data.lastName);
                    setSrvstrtdt(new Date(res.data.serviceStartDate));
                    //setCivilNumber(res.data.civilNumber);
                    setEmail(res.data.email);
                    setPhone(res?.data?.countryCode ? `+${res.data.countryCode}${res?.data?.phone}` : res?.data?.phone);
                    setGender(res.data.gender);
                    setDob(res.data.dob);
                    setTitle(res.data.title);
                    if (res.data.licenses) setLicenses(res.data.licenses);
                    setAddress(res.data.address);
                    setCountry(res.data.country);
                    setState(res.data.stateName);
                    setCity(res.data.city);
                    setQualification({ id: res?.data?.qualificationId, value: res?.data?.qualification });
                    // setDepartment(res.data.department);
                    setDepartment({ id: res?.data?.departmentId, value: res.data.department });
                    setSpecialization({ id: res?.data?.specialityId, value: res.data.speciality });
                    setPincode(res.data.pincode);
                    setClinic(res.data.clinicId);
                    setAdminId(res.data.adminId);
                    if(res.data.consultationFee) setFee(res.data.consultationFee);
                    setDomainName(res.data.subdomain);
                    setAlternatePhone(res.data.alternatePhone);
                    setPayment(res.data?.paymentType);
                    // let addChips = res?.data?.newconsultationFee?.length>0 && res?.data?.newconsultationFee.map(item => {
                    //     return {
                    //         country: item.country ? item.country.map(label => ({ label })) : [],
                    //         currency: item.currency,
                    //         symbol: item.symbol || item.currency,
                    //         amount: item.amount
                    //     };
                    // });
                    let addChips = res?.data?.newconsultationFee?.length > 0 && res?.data?.newconsultationFee.map(item => {
                        return {
                            country: item.country ? item.country.map(label => {
                                // Find the corresponding country data from your array of objects
                                const foundCountry = currencies.find(country => country.country === label);
                    
                                return foundCountry ? {
                                    value: foundCountry.countryCode,           // e.g., "AFN"
                                    label: foundCountry.country,        // e.g., "Afghanistan"
                                    countryCode: foundCountry.countryCode,
                                    currencyCode: foundCountry.code,    // e.g., "AFN"
                                    currencySymbol: foundCountry.symbol  || "" // e.g., "؋"
                                } : { label }; // Fallback to original label if not found
                            }) : [],
                            currency: item.currency,
                            symbol: item.symbol || item.currency,
                            amount: item.amount
                        };
                    });
                    setAddChips(addChips || [])
                }
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err ==== ", err);
            });
        }
    }, [props.active]);


    useEffect(() => {
        let _statesList = statesList.filter((state) => state.countryid === country);
        if (_statesList.length === 0) {
            _statesList = [{
                value: "",
                label: l.no_states_available
            }];
        } 
        _statesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
        setStates([..._statesList]);
        setCity(''); 
    }, [country]);

    useEffect(() => {
        let _citiesList = citiesList.filter((city) => city.stateid === state);
        if (_citiesList.length === 0) {
            _citiesList = [{
                value: "",
                label: l.no_cities_available
            }];
        } 
        _citiesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
        setCities(_citiesList);
    }, [state]);


    const handleDepartment = () => {
        let query = clinic ? `?clinicId=${clinic}&type=all` : '?type=all';

        // setLoading(true);
        getDepartmentList(query).then((res) => {
            if (res.status) {
                let defaultLabel = [...res?.data];
                defaultLabel.unshift({
                    name: '',
                    label: 'Select Department'
                });
                setDepartments(defaultLabel);
            }
        }).catch((err) => {
            toast.error(err?.response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT
            });
            if(API.isCancel(err)) {
                console.log("API is canceled................");
            } else {
                setLoading(false);
            }
        });
    };

    useEffect(() => {
        handleDepartment();
    }, [clinic]);


    const handleSpecialization = () => {
        setSmallLoading(true);
        let query = '';
        if (department?.id && department.value !== null) {
            query = `?id=${department?.id}`;
        }
        query = clinic ? `${query}&clinicId=${clinic}` : query ? query : '';
        getSpecialization(query).then((res) => {
            if (res.status) {
                let defaultLabel = [...res?.data];
                defaultLabel.unshift({
                    name: '',
                    label: 'Select Specialization'
                });
                setSpecializations(defaultLabel);
                setSmallLoading(false);

                // filterSpecialization();
            } else {
                setSmallLoading(false);

            }
            setLoading(false);
        }).catch((err) => {
            toast.error(err?.response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT
            });
            setSmallLoading(false);

        });
    };

    const validateSpc = () => {
        if (department?.id && department.id !== '' && department.value !== '') {
            handleSpecialization();
        } else {
            setSpecializations([]);
        }
    }

    useEffect(() => {
        validateSpc();
    }, [department]);



    const handleDegree = () => {
        // setLoading(true);
        let query = clinic ? `?clinicId=${clinic}` : "";
        getDegree(query).then((res) => {
            if (res.status) {
                let defaultLabel = [...res?.data];
                defaultLabel.unshift({
                    name: '',
                    label: 'Select Degree'
                });
                setDegrees(defaultLabel);
            } else {
                // console.log('something');
            }
            // setLoading(false);
        }).catch((err) => {
            toast.error(err?.response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT
            });
        });
    };

    useEffect(() => {
        handleDegree();
    }, [clinic]);



    const addLicense = () => {
        let license = {
            license: '',
            licenseNo: '',
            expirationDate: new Date().valueOf()
        };
        let _licenses = [...licenses];
        _licenses.push(license);
        setLicenses(_licenses);
    };

    const handleChange = (name, value, i) => {
        let _licenses = [...licenses];
        _licenses[i] = {
            ..._licenses[i],
            [name]: value
        };
        setLicenses(_licenses);
    };

    const removeLicense = (i) => {
        if (i > 0) {
            let _licenses = [...licenses];
            _licenses.splice(i, 1);
            setLicenses(_licenses);
        }
    };

    const handleCancel = () => {
        history.push('/admin-users/doctor');
    };

    const validateForm = () => {
        let _error = {};
        let returnValue = true;

        if (firstName === '' || firstName === null) {
            _error['firstName'] = l.pls_ent_fName;
            returnValue = false;
        }
        else if (!validateLetters(firstName)) {
            _error['firstName'] = l.pls_ent_letters_fName;
            returnValue = false;
        }
        if (lastName === '' || lastName === null) {
            _error['lastName'] = l.pls_ent_lName;
            returnValue = false;
        }
        else if (!validateLetters(lastName)) {
            _error['lastName'] = l.pls_ent_letters_lName;
            returnValue = false;
        }
        if (gender === '' || gender === null) {
            _error['gender'] = l.pls_sel_gender;
            returnValue = false;
        }
        if (dob === '' || dob === null) {
            _error['dob'] = l.pls_sel_dob;
            returnValue = false;
        }
        else if (!validateDcotorDob(dob)) {
            _error['dob'] = l.pls_check_doc_dob;
            returnValue = false;
        }
        if (email === '' || email === null) {
            _error['email'] = l.pls_enter_email;
            returnValue = false;
        }
        else if (!validateEmail(email)) {
            _error['email'] = l.pls_check_email;
            returnValue = false;
        }
        if (phone === '' || phone === null) {
            _error['phone'] = l.pls_enter_phone;
            returnValue = false;
        }
        else if (!isValidPhoneNumber(phone)) {
            _error['phone'] = l.pls_check_phone;
            returnValue = false;
        } else if (!valPnBoCc(phone)) {
            _error['phone'] = l.pls_check_phone;
            returnValue = false;
        }
        // { console.log("alternate phone--------------------->", alternatePhone) }
        if (alternatePhone && alternatePhone !== "") {
            // console.log("chking=============================>")
            const chkAlternatePhoneNumber = valPnBoCc(alternatePhone);
            // console.log("chkAlternatePhoneNumber", chkAlternatePhoneNumber)
            if (!chkAlternatePhoneNumber) {
                _error['alternatePhone'] = "Please check alternate phone number";
                returnValue = false;
            }
        }

        if (srvstrtdt === '' || srvstrtdt === null) {
            _error['srvstrtdt'] = l.pls_sel_service;
            returnValue = false;
        }
        else if (!validateSrvstrtDt(dateFormat(srvstrtdt))) {
            _error['srvstrtdt'] = l.pls_sel_service;
            returnValue = false;
        }
        if (dob > srvstrtdt.valueOf()) {
            _error['srvstrtdt'] = l.pls_sel_val_service;
            returnValue = false;
        }
        if (department.value === '' || department.value === null) {
            _error['department'] = l.pls_sel_dept;
            returnValue = false;
        }
        if (specialization.value === '' || specialization.value === null) {
            _error['specialization'] = l.pls_sel_speclz;
            returnValue = false;
        }
        if (qualification.value === '' || qualification.value === null) {
            _error['qualification'] = l.pls_sel_qualific;
            returnValue = false;
        }
        if (address === '' || address === null) {
            _error['address'] = l.pls_ent_addr;
            returnValue = false;
        }
        // if (country === '' || country == null) {
        //     _error['country'] = l.pls_sel_country
        //     returnValue = false
        // }
        // if (state === '' || state == null) {
        //     _error['state'] = l.pls_sel_state
        //     returnValue = false
        // }
        // if (city === '' || city == null) {
        //     _error['city'] = l.pls_sel_city
        //     returnValue = false
        // }
        // if (pincode === '' || pincode == null) {
        //     _error['pincode'] = l.pls_entr_pin
        //     returnValue = false
        // }
        // else if (!validatePincode(pincode)) {
        //     _error['pincode'] = l.pls_check_pin
        //     returnValue = false
        // }
        if (payment !== 'free') {
            if (error?.fee && error.fee !== "") {
                // console.log('1',error);
                _error['fee'] = error.fee;
                returnValue = false;
            }
            if (fee === '' || fee === null) {
                // console.log('2',error);
                _error['fee'] = l.pls_entr_fee;
                returnValue = false;
            } else if (!addDefaultFee){
                _error['fee'] = l.pls_add_fee;
                returnValue = false;
            }
            // else if (!validateIntegers(fee) || fee > 10000) {
            //     // console.log('3',error);
            //     _error['fee'] = l.pls_check_fee;
            //     returnValue = false;
            // }
        }
        if (domainName === '' || domainName === null) {
            _error['domainName'] = l.pls_entr_domain;
            returnValue = false;
        }
        // else if (clinic === '' || clinic == null) {
        //     setErrorMsg(l.pls_sel_clc)
        //     return false
        // }
        //  else if (adminId === '' || adminId === null) {
        //     setErrorMsg(l.pls_selt_admin)
        //     return false
        // }

        else {
            for (let i = 0; i < licenses.length; i++) {
                let number = i === 0 ? '1st ' : (i === 1 ? '2nd ' : (i + 1) + 'th ');
        
                if (licenses[i].license === '') {
                    _error['license'] = l.pls_select + ' ' + number + l.lic_type;
                    returnValue = false;
                    break; // Stop further checks once an error is found
                }
                else if (licenses[i].licenseNo === '' || !validateLicense(licenses[i].licenseNo)) {
                    _error['license'] = l.pls_entr_valid + ' ' + number + l.lic_numb;
                    returnValue = false;
                    break; // Stop further checks once an error is found
                }
                else if (licenses[i].expirationDate === '' || !validateDob(dateFormat(licenses[i].expirationDate))) {
                    _error['license'] = l.pls_entr_valid + ' ' + number + l.lic_exp_date;
                    returnValue = false;
                    break; // Stop further checks once an error is found
                }
                else if (licenses[i].country === '') {
                    _error['license'] = l.pls_sel_country_of + ' ' + number + l.license;
                    returnValue = false;
                    break; // Stop further checks once an error is found
                }
            }
        }
        
        console.log('error in creare doctor-----', _error, returnValue);
        setError(_error);
        return returnValue;
    };

    const handleCreateDoctor = async (e) => {

        //  e.preventDefault();
        // console.log('doctor created');
        try {
            if (validateForm()) {
                setLoading(true);
                const phoneNumber = parsePhoneNumber(phone);
                const countrycode = phoneNumber.countryCallingCode;
                const number = phoneNumber.nationalNumber;
                let body = {
                    adminId: adminId,
                    clinicId: role === "C" ? userId : clinic,
                    consultRole: 'doctor',
                    firstName: firstName.trim(),
                    lastName: lastName.trim(),
                    email: email.replaceAll(' ', '').toLowerCase(),
                    countryCode: countrycode,
                    phone: number,
                    alternatePhone: alternatePhone,
                    gender: gender.trim(),
                    dob: dob,
                    title: title,
                    serviceStartDate: srvstrtdt.valueOf(),
                    licenses: licenses,
                    address: address,
                    country: country ? country : '',
                    stateName: state ? state : '',
                    city: city ? city : '',
                    departmentId: department.id,
                    department: department.value.trim(),
                    specialityId: specialization.id,
                    speciality: specialization.value.trim(),
                    qualificationId: qualification.id,
                    qualification: qualification.value.trim(),
                    // pincode: pincode.trim() ? pincode.trim() : '',
                    paymentType: payment
                    // subdomain: role !== "C" ? domainName : _domain.subDomains && _domain.subDomains[0] ? _domain.subDomains[0] : _domain.hostname
                };
                currency && (body["currency"] = currency.trim())
                pincode && (body["pincode"] = pincode.trim())
                body.newconsultationFee = []
                // console.log("body.newconsultationFee", body.newconsultationFee)
                // console.log("..............body", body, fee)
                if (payment !== 'free') {
                    body['consultationFee'] = fee;
                    addChips && addChips.length > 0 && addChips.forEach((chip)=>{
                        let coun = chip?.country?.length > 0 && chip?.country?.map(country => country.label);
                        // console.log(".......................",coun, JSON.stringify(chip?.country, null, 2))
                        let addchip = {
                            country : coun,
                            currency : chip?.currency,
                            symbol : chip?.symbol ||  chip?.currency,
                            amount :  Number(chip?.amount)
                        }
                        body.newconsultationFee.push(addchip)
                    })
                }
                // return
                if (dId) {
                    // body['adminId'] = adminId
                    updateUser(dId, body).then(res => {
                        setLoading(false);
                        if (res.status) {
                            setErrorMsg(null)
                            toast.success(l.doc_upd_succ, {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            history.push(`/clinic-users?dId=${dId}`);
                        }
                    }).catch(err => {
                        setLoading(false);
                        // let msg = err?.response?.data?.error?.message ? err.response.data.error.message : err?.response?.data?.error ? err.response.data.error : l.unable_upd_doc;
                        toast.error(err.errorMessage, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setErrorMsg(l.unable_upd_doc);
                    });
                }
                else {
                    // body['adminId'] = adminId
                    createUser(body, role === "C").then(res => {
                        setLoading(false);
                        if (res.status) {
                            setErrorMsg(null)
                            toast.success(l.doc_created_success, {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            // history.push('/admin-users/doctor');
                            history.push('/clinic-createusers');
                        }
                    }).catch(err => {
                        console.log("error in create doctor ====", err.response);
                        setLoading(false);
                        let msg = err?.response?.data?.error?.message ? err.response.data.error.message : err?.response?.data?.error ? err.response.data.error : l.unable_crt_doc;
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setErrorMsg(msg);
                    });
                }
            }
            else {
                if (errorMsg != null) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }
            }
        } catch (err) {
            setLoading(false);
            toast.error(err.errorMessage, {
                position: toast.POSITION.TOP_RIGHT
            });
            console.log("Error", err);
            setErrorMsg(l.went_worng_pls_try_again);
        }
    };

    const handleVerify = () => {
        setopenPopup(prevState => !prevState);
        history.push('/admin-users/doctor');
        toast.success("Doctor created successfully", {
            position: toast.POSITION.TOP_RIGHT
        });
    };

    // const handleCurrency = () => {

    //     // console.log("currency, fee,............................:", currency, fee);
    //     if (!currency) {
    //         toast.success("Please select the currency type", {
    //             position: toast.POSITION.TOP_RIGHT
    //         });
    //     }

    //     if (currency === "USD") {
    //         if (fee < 0.50) {
    //             setError({ ...error, fee: `Please enter fee more then ${1} ${currency}` });
    //         } else {
    //             setError({ ...error, fee: "" });
    //         }
    //     }
    //     else if (currency !== "USD") {
    //         let from = currency.toLowerCase();
    //         // axios.get(`https://cdn.jsdelivr.net/gh/fawazahmed0/currency-api@1/latest/currencies/${from}.json`)
    //         getAxios(from)
    //             .then((res) => {
    //                 console.log("ytrwyqtfwtyytwfwyywuywuy", JSON.parse(res.data));
    //                 let result = fee * JSON.parse(res.data)[from].usd;
    //                 // console.log('...................', result);
    //                 if (result < 0.50) {
    //                     setError({ ...error, fee: `Please enter fee more then ${Math.ceil(0.50 / JSON.parse(res.data)[from].usd)} ${currency}` });
    //                 } else {
    //                     setError({ ...error, fee: "" });
    //                 }
    //             })
    //             .catch((err) => {
    //                 console.log("err..........................:", err);
    //             });
    //     }

    // };

    // useEffect(() => {
    //     handleCurrency();
    // }, [fee, currency, payment]);

    const handleDepVal = () => {
        // if (e.target.value) {
        //     setDeptVal('');
        // }
        if (role !== "C" && !dId && clinic !== '') {
            setCreatePopup('DEPARMENT');
        } else if (role === "C") {
            setCreatePopup('DEPARMENT');
        } else {
            setErrorMsg(l.pls_sel_clc);
            setError(({ ...error, clinic: l.pls_sel_clc }));
        }
    };

    const handleSpeVal = (e) => {
        // if (e.target.value) {
        //     setDeptVal('');
        // }
        if (role !== "C" && !dId && clinic !== '' && department !== "") {
            setCreatePopup('specialization');
        } else if (role === "C" && department !== "") {
            setCreatePopup('specialization');
        } else if (role !== "C" && !dId && clinic === '' && department.id === "") {
            setErrorMsg(l.pls_sel_clc);
            setError(({ ...error, clinic: l.pls_sel_clc, department: l.pls_sel_dept }));
        } else if (role !== "C" && !dId && clinic === "") {
            setError(({ ...error, clinic: l.pls_sel_clc }));
        } else if ((role !== "C" && !dId && department.id === "") || (role === "C" && department.id === "")) {
            setError(({ ...error, department: l.pls_sel_dept }));
        }
    };

    const handleDeprtUpdate = (e) => {
        const departobj = departments.find(x => x?.name === e.target.value);
        if(departobj){
            setDepartment({ id: departobj?._id, value: departobj?.name });
            setSpecialization({ id: '', value: '' });
            setError(({ ...error, department: '' }));
        } else {
            setDepartment({ id: '', value: '' });
            setError(({ ...error, department: l.pls_sel_dept }));
        }
    };

    const handleSpecilizationUpdate = (e) => {
        const specilityobj = specializations.find(x => x?.name === e.target.value);
        if(specilityobj){
            setSpecialization({ id: specilityobj?._id, value: specilityobj?.name });
            setError(({ ...error, specialization: '' }));
        } else {
            setSpecialization({ id: '', value: ''});  
            setError(({ ...error, specialization: l.pls_sel_speclz }));      
        }
    };

    const handleDegreeValue = (e) => {
        const qualificationobj = degrees.find(x => x?.name === e.target.value);

        setQualification({ id: qualificationobj._id, value: qualificationobj.name });
        setError(({ ...error, qualification: '' }));
    };

    const handleDegVal = () => {
        if (role !== "C" && !dId && clinic !== '') {
            setCreatePopup('DEGREE');
        } else if (role === "C") {
            setCreatePopup('DEGREE');
        } else {
            setErrorMsg(l.pls_sel_clc);
            setError(({ ...error, clinic: l.pls_sel_clc }));
        }
    };

    // const filterSpecialization = () => {
    // if (department !== "" && department !== null) {
    //     const departobj = departments.find(x => x?.name === department)
    //     console.log("departobj?._id..................:", departobj?._id, specializations)
    //     const specobj = specializations?.filter(x => x?.departmentIds?.includes(departobj?._id))

    //     console.log(".................:", specobj);
    //     if (specobj && specobj.length > 0) {
    //         specobj.unshift({
    //             name: '',
    //             label: 'Select Specialization'
    //         })
    //         setSpecializations(specobj);
    //     }
    // }
    // }

    // useEffect(() => {
    //     filterSpecialization();
    // }, [department])

    return (
        loading ? <Loader /> : <Fragment>
            <div className="formCol alignCenter justifyCenter">
                <div className="formListGroup">
                    {errorMsg &&
                        <div className="errorBox">
                            <small className="errorTxt">{errorMsg}</small>
                        </div>
                    }
                    <div className="colBlock">
                        <form onSubmit={handleCreateDoctor}>
                            <small className="inpLabel">{l.inp_fname}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.inp_fname}
                                type="text"
                                pattern="[a-zA-Z]+"
                                value={firstName}
                                error={error && error.firstName}
                                errorMsg={error.firstName}
                                maxLength="30"
                                onChange={(e) => {
                                    setError(prevError => ({
                                        ...prevError,
                                        firstName: ''
                                      }));
                                    setfirstName(e.target.value)}}
                            />
                            <small className="inpLabel">{l.inp_lname}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.inp_lname}
                                type="text"
                                value={lastName}
                                error={error && error.lastName}
                                errorMsg={error.lastName}
                                maxLength="30"
                                onChange={(e) =>{
                                    setError(prevError => ({
                                        ...prevError,
                                        lastName: ''
                                      }));
                                    setLastName(e.target.value)}}
                            />
                            <small className="inpLabel">{l.label_gender}<span className="redTxt">*</span>:</small>
                            <div className="inputRowFeild">
                                {/* <p className="inputRowLabel">{l.label_gender}<span className="redTxt">*</span>:</p> */}
                                <div className="hozRadioGroup">
                                    <div className={gender === "male" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                        <Radio id="male" name="gender" label={l.male} value="male" checked={gender === "male" ? true : false} onChange={(e) => setGender(e.target.value)} />
                                        {/* <img className={gender === "M" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/male.png" alt="gendericon" /> */}
                                        {/* <span>{l.male}</span> */}

                                    </div>
                                    <div className={gender === "female" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                        <Radio id="female" name="gender" label={l.female} value="female" checked={gender === "female" ? true : false} onChange={(e) => setGender(e.target.value)} />
                                        {/* <img className={gender === "F" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/female.png" alt="gendericon" /> */}
                                        {/* <span >{l.female}</span> */}
                                    </div>
                                    <div className={gender === "others" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                        <Radio id="others" name="gender" label={l.others} value="others" checked={gender === "others" ? true : false} onChange={(e) => setGender(e.target.value)} />
                                        {/* <span>{l.others}</span> */}
                                    </div>
                                </div>
                                {(error && error.gender) && <span className="inputErrorMsg">{error.gender}</span>}
                            </div>
                            <small className="inpLabel">{l.dob}<span className="redTxt">*</span>:</small>
                            <div className="inputBox alignCenter">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker fullWidth
                                        className="pickerInput marginL"
                                        inputVariant="outlined"
                                        value={dob}
                                        onChange={(date) =>{error['dob']='';
                                             setDob(date && date.valueOf())}}
                                        animateYearScrolling
                                        placeholdertext={l.dob}
                                        maxDate={new Date().setFullYear(maxYear)}
                                        format="dd/MM/yyyy"

                                    />

                                    {/*<div className="inputIconBox"><img src="/images/icons/date.png" className="invertGray" alt="date"/></div>*/}
                                </MuiPickersUtilsProvider>
                            </div>
                            {(error && error.dob) && <span className="inputErrorMsg">{error.dob}</span>}
                            <small className="inpLabel">{l.email_address}<span className="redTxt">*</span>:</small>

                            {dId ?
                                <div className="pTxt">
                                    {email}
                                </div> :

                                <InputField
                                    placeholder={l.email_address}
                                    type="email"
                                    value={email.replaceAll(' ', '').toLowerCase()}
                                    error={error && error.email}
                                    errorMsg={error.email}
                                    maxLength="50"
                                    onChange={(e) => {
                                        setError(prevError => ({
                                            ...prevError,
                                            email: ''
                                          }));
                                        setEmail(e.target.value)}}
                                />
                            }
                            <div className="inputRowFeild">

                                <small className="inpLabel">{l.edit_phone_no}<span className="redTxt">*</span>:</small>
                                <div className="inputBox colBlock nopdng">
                                    <PhoneInput className="customPkgInput nopdng"
                                        international
                                        countryCallingCodeEditable={false}
                                        defaultCountry="IN"
                                        maxLength="17"
                                        value={phone}
                                        // error={error && error.phone}
                                        // errorMsg={error.phone}
                                        onChange={setPhone} />
                                    <label>{props.label}</label>
                                    {(error && error.phone) && <span className="inputErrorMsg">{error.phone}</span>}
                                </div>

                                <small className="inpLabel">{l.edit_alt_phone_no}:</small>
                                {/* <InputField
                                    placeholder={l.edit_alt_phone_no}
                                    type="text"
                                    value={alternatePhone}
                                    maxLength={12}
                                    onChange={(e) => setAlternatePhone(e.target.value)}
                                /> */}
                                <div className="inputBox colBlock nopdng">

                                    <PhoneInput className="customPkgInput nopdng"
                                        international
                                        countryCallingCodeEditable={false}
                                        defaultCountry="IN"
                                        maxLength="17"
                                        value={alternatePhone}
                                        // error={error && error.phone}
                                        // errorMsg={error.phone}
                                        onChange={setAlternatePhone}
                                    />
                                    {(error && error.alternatePhone) && <span className="inputErrorMsg">{error.alternatePhone}</span>}
                                </div>
                                <small className="inpLabel">{l.service_startdate}<span className="redTxt">*</span>:</small>
                                <div className="inputBox alignCenter">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker fullWidth
                                            className="pickerInput"
                                            inputVariant="outlined"
                                            value={srvstrtdt}
                                            onChange={(date) => setSrvstrtdt(date)}
                                            animateYearScrolling
                                            placeholdertext={l.service_startdate}
                                            maxDate={new Date()}
                                            format="dd/MM/yyyy"
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                {(error && error.srvstrtdt) && <span className="inputErrorMsg">{error.srvstrtdt}</span>}
                                {role !== "C" && !dId && <Fragment>
                                    <small className="inpLabel">{l.ass_clinic}<span className="redTxt">*</span>:</small>
                                    <DropDown
                                        placeholder={l.ass_clinic}
                                        items={clinics}
                                        value={clinic}
                                        error={error && error.clinic}
                                        errorMsg={error?.clinic}
                                        onChange={(e) => {
                                            setClinic(e.target.value);
                                            setErrorMsg("");
                                            setError({ ...error, clinic: '' });
                                        }
                                        }
                                    />
                                </Fragment>}
                                <small className="inpLabel">{l.select_department}<span className="redTxt">*</span>:</small>
                                {departments && departments.length > 1 ?
                                    <DropDown
                                        placeholder={l.select_department}
                                        id={department?.id}
                                        items={departments}
                                        value={department?.value}
                                        config='dept'
                                        error={error && error.department}
                                        errorMsg={error.department}
                                        onChange={handleDeprtUpdate}
                                    /> :
                                    <InputField
                                        onClick={handleDepVal}
                                        id="outlined-textarea"
                                        variant="outlined"
                                        size="small"
                                        // value={deptValue}
                                        // onChange={(e) => handleDepVal(e)}
                                        className="whiteBg"
                                        maxLength="30"
                                        errorMsg={error.department}
                                        placeholder="Create Department"
                                        error={error && error.department}
                                    />

                                }
                                <small className="inpLabel">{l.select_specialist}<span className="redTxt">*</span>:</small>
                                {smallLoading && <LoaderSmall />}
                                {!smallLoading && (specializations && specializations.length > 1 ? <DropDown
                                    placeholder={l.select_specialist}
                                    items={specializations}
                                    value={specialization?.value}
                                    config='spec'
                                    error={error && error.specialization}
                                    errorMsg={error.specialization}
                                    onChange={handleSpecilizationUpdate}
                                /> : department?.id && department.id !== '' ?
                                    <InputField
                                        onClick={handleSpeVal} //{() => setCreatePopup('specialization')}
                                        id="outlined-textarea"
                                        variant="outlined"
                                        size="small"
                                        className="whiteBg"
                                        maxLength="30"
                                        placeholder="Create Specialization"
                                        error={error && error.specialization}
                                        errorMsg={error.specialization}
                                    />
                                    :
                                    <InputField
                                        // onClick={handleSpeVal} //{() => setCreatePopup('specialization')}
                                        id="outlined-textarea"
                                        variant="outlined"
                                        size="small"
                                        // className="disabledStripeInput"
                                        maxLength="30"
                                        placeholder="Please Select Department"
                                        readOnly= 'true'
                                    // error={error && error.specialization}
                                    // errorMsg={error.specialization}
                                    />
                                    )

                                }
                                {/* {smallLoading && <LoaderSmall/>} */}
                                <small className="inpLabel">{l.select_degree}<span className="redTxt">*</span>:</small>
                                {degrees && degrees.length > 1 ? <DropDown
                                    placeholder={l.select_degree}
                                    items={degrees}
                                    value={qualification.value}
                                    config='deg'
                                    error={error && error.qualification}
                                    errorMsg={error.qualification}
                                    onChange={handleDegreeValue}
                                /> :
                                    // <Button
                                    //     label={l.select_degree}
                                    //     type='outLine'
                                    //     size='md'
                                    //     onClick={() => setCreatePopup('DEGREE')}
                                    // />
                                    <InputField
                                        onClick={handleDegVal}           //{() => setCreatePopup('DEGREE')}
                                        id="outlined-textarea"
                                        variant="outlined"
                                        size="small"
                                        placeholder="Create Degree"
                                        className="whiteBg"
                                        maxLength="30"
                                        error={error && error.qualification}
                                        errorMsg={error.qualification}
                                    />
                                }
                                <small className="inpLabel">{l.pat_address}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.pat_address}
                                    type="text"
                                    value={address}
                                    error={error && error.address}
                                    errorMsg={error.address}
                                    maxLength="100"
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                                <small className="inpLabel">{l.select_country}:
                                    {/* <span className="redTxt">*</span> */}

                                </small>
                                <AddrDropDown
                                    // placeholder={l.select_country}
                                    items={countriesList}
                                    value={country}
                                    error={error && error.country}
                                    errorMsg={error.country}
                                    onChange={(e) => setCountry(e.target.value)}
                                />
                                <small className="inpLabel">{l.select_state}:
                                    {/* <span className="redTxt">*</span> */}
                                </small>
                                <AddrDropDown
                                    placeholder={l.select_state}
                                    items={states}
                                    value={state}
                                    error={error && error.state}
                                    errorMsg={error.state}
                                    onChange={(e) => setState(e.target.value)}
                                />
                                <small className="inpLabel">{l.select_city}:
                                    {/* <span className="redTxt">*</span> */}
                                </small>
                                <AddrDropDown
                                    placeholder={l.select_city}
                                    items={cities}
                                    value={city}
                                    error={error && error.city}
                                    errorMsg={error.city}
                                    onChange={(e) => setCity(e.target.value)}
                                />
                                <small className="inpLabel">{l.edit_pin}:
                                    {/* <span className="redTxt">*</span> */}
                                </small>
                                <InputField
                                    placeholder={l.edit_pin}
                                    type="text"
                                    maxLength={15}
                                    value={pincode}
                                    error={error && error.pincode}
                                    errorMsg={error.pincode}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                            setPincode(value); // Only set value if it is numeric
                                        }
                                    }}
                                />

                                <small className="inpLabel">{l.payment}<span className="redTxt">*</span>:</small>
                                <div className="inputRowFeild">
                                    {/* <p className="inputRowLabel">{l.label_gender}<span className="redTxt">*</span>:</p> */}
                                    <div className="hozRadioGroup">
                                        <div className={payment === "free" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                            <Radio id="free" name="free" value="free" label={l.free_appointment} checked={payment === "free" ? true : false} onChange={(e) => setPayment(e.target.value)} />
                                            {/* <img className={gender === "M" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/male.png" alt="gendericon" /> */}
                                            {/* <span>{l.free_appointment}</span> */}

                                        </div>
                                        <div className={payment === "prePaid" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                            <Radio id="prePaid" name="prePaid" label={l.pre_appointment} value="prePaid" checked={payment === "prePaid" ? true : false} 
                                            onChange={(e) => {
                                                setPayment(e.target.value)
                                                setError({
                                                    ...error, 
                                                    newFees: "", 
                                                    fee: ""
                                                  });
                                                // setAddDefaultFee(false)
                                                }
                                                } />
                                            {/* <img className={gender === "F" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/female.png" alt="gendericon" /> */}
                                            {/* <span>{l.pre_appointment}</span> */}
                                        </div>
                                        {/* <div className={payment === "postPaid" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                            <Radio id="postPaid" name="postPaid" value="postPaid" checked={payment === "postPaid" ? true : false} onChange={(e) => setPayment(e.target.value)} />
                                            <span>{l.post_appointment}</span>
                                        </div> */}
                                    </div>
                                    {/* {(error && error.gender) && <span className="inputErrorMsg">{error.gender}</span>} */}
                                </div>

                                {/* {payment !== 'free' &&
                                    <>
                                        <small className="inpLabel">{l.label_currency}<span className="redTxt">*</span>:</small>
                                        <div className="inputRowFeild">
                                            <div className="hozRadioGroup">
                                                <div className={currency === "INR" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                                    <Radio id="INR" name="currency" label="INR" value="INR" checked={currency === "INR" ? true : false} onChange={(e) => setCurrency(e.target.value)} />
                                                </div>
                                                <div className={currency === "USD" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                                    <Radio id="USD" name="currency" label="USD" value="USD" checked={currency === "USD" ? true : false} onChange={(e) => setCurrency(e.target.value)} />
                                                </div>
                                                <div className={currency === "AED" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                                    <Radio id="AED" name="currency" label="AED" value="AED" checked={currency === "AED" ? true : false} onChange={(e) => setCurrency(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>

                                        <small className="inpLabel">{l.consultation_fee}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            placeholder={l.consultation_fee}
                                            type="text"
                                            value={fee}
                                            error={error && error.fee}
                                            // maxLength={5}
                                            errorMsg={error.fee}
                                            pattern="[0-9]{2,5}"
                                            onChange={(e) => setFee(e.target.value)}
                                        />

                                    </>
                                } */}
                                {/* {console.log("aaaaaa:::::::",addChips)
                                } */}
                                {payment !== 'free' && <AddCurrency addChips={addChips} setAddChips={setAddChips}  defaultCurrency={currency} setDefaultCurrency={setCurrency} defaultAmount={fee} setDefaultAmount={setFee} errorMsg={error} setErrorMsg={setError} defaultFee={addDefaultFee} setDefaulFee={setAddDefaultFee}/>}
                                {/* {role !== "C" && <Fragment>
                                    <small className="inpLabel">{l.edit_clc_domain_name}<span className="redTxt">*</span>:</small>
                                    <InputField
                                        placeholder={l.edit_clc_domain_name}
                                        type="text"
                                        value={domainName}
                                        onChange={(e) => setDomainName(e.target.value)}
                                    />
                                </Fragment>} */}
                            </div>
                            <div className="inputRowFeild medicalInputs">
                                {(error && error.license) && <span className="inputErrorMsg">{error.license}</span>}
                                {licenses.map((license, i) =>
                                    <AddLicense data={license} key={i} index={i} handleChange={handleChange} removeLicense={removeLicense} />
                                )}
                                <div>
                                    <Button size="sm" className="btn" type="outLine" label={l.add_anthr} onClick={addLicense} />
                                </div>
                            </div>
                            {role === "SA" && !dId && <Fragment>
                                <small className="inpLabel">{l.ass_admin}<span className="redTxt">*</span>:</small>
                                <DropDown
                                    placeholder={l.ass_admin}
                                    items={admins}
                                    value={adminId}
                                    error={error && error.adminId}
                                    errorMsg={error.adminId}
                                    onChange={(e) => setAdminId(e.target.value)}
                                />
                            </Fragment>}

                            {/* {role !== "C" && !dId && <Fragment>
                                <small className="inpLabel">{l.ass_clinic}<span className="redTxt">*</span>:</small>
                                <DropDown
                                    placeholder={l.ass_clinic}
                                    items={clinics}
                                    value={clinic}
                                    error={error && error.clinic}
                                    errorMsg={error.clinic}
                                    onChange={(e) => setClinic(e.target.value)}
                                />
                            </Fragment>} */}
                            <div className="crdBtnContainer">
                                <div className="rowBlock">
                                    <Button
                                        label={l.cancel}
                                        type='outLine'
                                        size='md'
                                        onClick={handleCancel}
                                    />
                                    <Button
                                        label={dId ? `${l.upd_doc}` : `${l.crt_doc}`}
                                        //  buttonType="submit"
                                        onClick={handleCreateDoctor}
                                        type='primary'
                                        size='md'
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {openPopup &&
                <VerifyPopup openVerify={openPopup} phone={phone.trim()} closePopup={handleVerify} handleVerify={handleVerify} />}
            {newpopup !== '' && (
                <CreatePopUp
                    open={newpopup !== ''}
                    newpopup={newpopup}
                    handleClose={() => {
                        setCreatePopup('');
                    }}
                    setCreate={setCreate}

                />
            )}
            {create === "DEPARMENT" && <CreateDepartment open={true} handleClose={() => {
                setCreate('');
                handleDepartment();
            }
            } />}
            {create === "specialization" && <CreateSpecialization open={true} handleClose={() => {
                setCreate('');
                validateSpc();
            }
            } />}
            {create === "DEGREE" && <CreateDegree open={true} handleClose={() => {
                setCreate('');
                handleDegree();
            }
            } />}
        </Fragment>
    );
};

export default CreateDoctorForm;





// <div className="inputRowFeild">
//     <p className="inputRowLabel">User Profile</p>
//     <DropDown
//         placeholder={l.select_title}
//         items={titleList}
//         value={title}
//         onChange={(e) => setTitle(e.target.value)}
//     />
//     <InputField
//         placeholder="Phone Number"
//         type="text"
//         value={phone}
//         onChange={(e) => setPhone(e.target.value)}
//     />
//     <InputField
//         placeholder="Alternate Number"
//         type="text"
//         value={alternatePhone}
//         onChange={(e) => setAlternatePhone(e.target.value)}
//     />
//     <DropDown
//         placeholder={l.select_department}
//         items={departments}
//         value={department}
//         onChange={(e) => setDepartment(e.target.value)}
//     />
//     <DropDown
//         placeholder={l.select_specialist}
//         items={docSpecialist}
//         value={specialist}
//         onChange={(e) => setSpecialist(e.target.value)}
//     />
//     <DropDown
//         placeholder="Degree"
//         items={degreeList}
//         value={degree}
//         onChange={(e) => setDegree(e.target.value)}
//     />
//     <DropDown
//         placeholder={l.select_state}
//         items={states}
//         value={state}
//         onChange={(e) => setState(e.target.value)}
//     />
//     <DropDown
//         placeholder={l.select_division}
//         items={divisions}
//         value={division}
//         onChange={(e) => setDivision(e.target.value)}
//     />
//     <DropDown
//         placeholder={l.select_city}
//         items={districtList}
//         value={district}
//         onChange={(e) => setDistrict(e.target.value)}
//     />
//     <InputField
//         placeholder={l.edit_pin}
//         type="text"
//         value={pincode}
//         onChange={(e) => setPincode(e.target.value)}
//     />
// </div>
// <div className="inputRowFeild medicalInputs">
//     <p className="inputRowLabel">Medical Profile</p>
//     <div className="colBlock">
//     <DropDown
//         placeholder="Medical License"
//         items={licenseList}
//         value={license}
//         onChange={(e) => setLicense(e.target.value)}
//     />
//     <InputField
//         placeholder="License Number"
//         type="text"
//         value={licenseNo}
//         onChange={(e) => setlicenseNo(e.target.value)}
//     />
//     <InputField
//         placeholder="Expiration Date"
//         type="text"
//         value={expirationDate}
//         onChange={(e) => setExpirationDate(e.target.value)}
//     />
//     </div>
//     <div>
//     <Button size="sm" className="btn" type="outLine" label="Add Another" />
// </div>
// </div>

// <div className="crdBtnContainer">
//     <Button
//         label={dId ? "Update Docotor" : "Create Doctor"}
//         buttonType="submit"
//         type='primary'
//         size='md'
//         fullWidth="fullWidth"
//     />
// </div>
// </form>